













import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatBody from '@/components/Chat/ChatBody.vue';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    components: {
        ChatBody,
    },
})
export default class Comments extends Vue {
    @Prop({ default: 'create' }) public mode: string;
    @Prop({ default: [] }) public comments: any;

    public close() {
        if (this.comments) {
            if (this.comments.comments.length) {
                const lastMessage = Math.max.apply(Math, this.comments.comments.map((comment: any) => comment.id));

                this.$store.dispatch(Actions.MARK_COMMENT_AS_SEEN, {
                    conversationId: this.comments.id,
                    lastMessageId: lastMessage,
                });
            }
        }

        this.$store.commit(Mutations.SET_ACTIVE_NOTIFICATION_MEDIA, null);
        this.$store.commit(Mutations.HIDE_EDIT_NOTIFICATION_FORM);
        this.$store.commit(Mutations.HIDE_EDIT_EVENT_FORM);
        this.$store.commit(Mutations.RESET_RECIPIENTS);
    }
}
